import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';
import { fromAdUser } from '../reducers';
import { UserProfile } from '../models';

type AdUserState = MemoizedSelector<object, fromAdUser.AdUserState>;

export const getAdUserRootState: AdUserState = createFeatureSelector<fromAdUser.AdUserState>(
  'adUser'
);
export const getAdUserState: AdUserState = createSelector(
  getAdUserRootState,
  state => state
);

const adalUserSelectors = fromAdUser.adalUserAdapter.getSelectors(getAdUserState);
export const getAllAdUserItems: (state: object) => UserProfile[] = adalUserSelectors.selectAll;
export const getAdUserEntities: (state: object) => Dictionary<UserProfile> =
  adalUserSelectors.selectEntities;

export const getAdUserEntitiesById: MemoizedSelector<
  object,
  Record<string, UserProfile>
> = createSelector(
  getAllAdUserItems,
  (users: UserProfile[]) => {
    return users.reduce((entities: Record<string, UserProfile>, detail: UserProfile) => {
      return {
        ...entities,
        [detail.objectId]: detail
      };
    }, {});
  }
);

export const getAdUserDetailsById: (id: string) => MemoizedSelector<object, UserProfile> = (
  id: string
) =>
  createSelector(
    getAdUserEntitiesById,
    entities => entities[id]
  );

export const getAdUserDetailsByEmail: (
  email: string
) => MemoizedSelector<object, UserProfile | undefined> = (email: string) =>
  createSelector(
    getAdUserEntities,
    entities => entities[fromAdUser.parseUserEmail(email)]
  );
/**
 * Selector to return the loading property of the state
 */
export const getAdalUserLoading: MemoizedSelector<object, boolean> = createSelector(
  getAdUserState,
  fromAdUser.getAdUserLoading
);

export const getCurrentUserProfile: MemoizedSelector<object, UserProfile> = createSelector(
  getAdUserState,
  state => {
    return state && state.currentUser;
  }
);
